import { useCallback } from "react";
import useToast from "../contexts/Toast/useToast";
import { useTranslation } from "react-i18next";
import { ErrorReportOptions, ReportedError } from "@/utils/reportError";
import { getErrorMessage } from "@/utils/getErrorMessage";
import { appLogger } from "@/utils/AppLogger";

export const useErrorHandler = () => {
  const { showErrorToast } = useToast();
  const { t } = useTranslation();

  const errorHandler = useCallback(
    async (error: ReportedError, options: ErrorReportOptions) => {
      if (options.showToast) {
        const toastMessage = (options.errorCode && t(options.errorCode)) || options.errorMessage || t("failMessage.toast");
        showErrorToast(toastMessage);
      }

      appLogger(getErrorMessage(error), { type: "error", errorReportOptions: options });
    },
    [showErrorToast, t],
  );

  return { errorHandler };
};
